import { filter } from 'lodash';

import store from '../store';
import { currentCompanyRights, allCurrentUsersRights } from '../modules/currentuser/selectors';
// import { detailPerson } from '../modules/persons/selectors';

function currentUserHasRights(rightsToCheck, idcompany) {
    const state = store.getState();
    let result = false;

    const allCurentUserRights = allCurrentUsersRights(state);
    const allCompanyRights = filter(allCurentUserRights, function (r) {
        return r.securableEntity_KeyName == 'Company' && 
        (r.entityId == idcompany || (r.childIds && r.childIds.includes(idcompany)))
    }).map(r => r.right);
    
    result = rightsToCheck.some(right => allCompanyRights.includes(right));

    // console.log('check on:', rightsToCheck)
    // console.log('rightscheck result:', result)

    return result;
}

export default currentUserHasRights;